/*
  This directive should be called on the FORM tag where we want to set the focus on the first invalid element when submit fail
*/

function ogFocusOnError() {
  return {
    restrict: 'A',
    link: function (scope, elem) {
      // set up event handler on the form element
      elem.on('submit', () => {
        // find the first invalid element
        const firstInvalid = elem[0].querySelector('input.ng-invalid, textarea.ng-invalid, select.ng-invalid');
        // if we find one, set focus
        if (firstInvalid) {
          firstInvalid.focus();
        }
      });
    }
  };
}

ogFocusOnError.$inject = [];

module.exports = ogFocusOnError;
